import { configure } from "mobx"
import { enableStaticRendering } from "mobx-react"
import { isServer } from "@lib/isomorphic"
import { config } from "@lib/config"

import { ResponsiveModel } from "./responsive.model"
import { SubscriptionModel } from "./subscription.model"
import { ModalModel } from "./modal.model"
import { FaqModel } from "./faq.model"
import { AnalyticsModel } from "./analytics.model"
import { BlogModel } from "./blog.model"
import { GlobalModel } from "./global.model"
import { ContactUsModel } from "./contact-us.model"
import { VacanciesModel } from "./vacancies.model"
import { LegalModel } from "./legal.model"
import { TeamPageModel } from "./team-page.model"
import { GDPRModel } from "./gdpr.model"
import { SaferDatingModel } from "./safer-dating.model"

configure({ enforceActions: "observed" })
enableStaticRendering(isServer())

interface InitParams {
  ResponsiveModel: ResponsiveModel
  AnalyticsModel: AnalyticsModel
  GlobalModel: GlobalModel
  BlogModel: BlogModel
  SubscriptionModel: SubscriptionModel
  ModalModel: ModalModel
  FaqModel: FaqModel
  ContactUsModel: ContactUsModel
  VacanciesModel: VacanciesModel
  LegalModel: LegalModel
  TeamPageModel: TeamPageModel
  GDPRModel: GDPRModel
  SaferDatingModel: SaferDatingModel
}

export class AppModels {
  ResponsiveModel!: ResponsiveModel
  AnalyticsModel!: AnalyticsModel
  GlobalModel!: GlobalModel
  BlogModel!: BlogModel
  SubscriptionModel!: SubscriptionModel
  ModalModel!: ModalModel
  FaqModel!: FaqModel
  ContactUsModel!: ContactUsModel
  VacanciesModel!: VacanciesModel
  LegalModel!: LegalModel
  TeamPageModel!: TeamPageModel
  GDPRModel!: GDPRModel
  SaferDatingModel!: SaferDatingModel

  hydrated = false

  init({
    ResponsiveModel,
    AnalyticsModel,
    GlobalModel,
    BlogModel,
    SubscriptionModel,
    ModalModel,
    FaqModel,
    ContactUsModel,
    VacanciesModel,
    LegalModel,
    TeamPageModel,
    GDPRModel,
    SaferDatingModel,
  }: InitParams) {
    this.ResponsiveModel = ResponsiveModel
    this.AnalyticsModel = AnalyticsModel
    this.GlobalModel = GlobalModel
    this.BlogModel = BlogModel
    this.SubscriptionModel = SubscriptionModel
    this.ModalModel = ModalModel
    this.FaqModel = FaqModel
    this.ContactUsModel = ContactUsModel
    this.VacanciesModel = VacanciesModel
    this.LegalModel = LegalModel
    this.TeamPageModel = TeamPageModel
    this.GDPRModel = GDPRModel
    this.SaferDatingModel = SaferDatingModel
  }

  // @ts-ignore
  hydrate(data) {
    this.hydrated = true
    this.GlobalModel.hydrate(JSON.parse(data?.GlobalModel))
    this.BlogModel.hydrate(JSON.parse(data?.BlogModel))
    this.SubscriptionModel.hydrate(JSON.parse(data?.SubscriptionModel))
    this.FaqModel.hydrate(JSON.parse(data?.FaqModel))
    this.ResponsiveModel.hydrate(JSON.parse(data?.ResponsiveModel))
    this.ContactUsModel.hydrate(JSON.parse(data?.ContactUsModel))
    this.VacanciesModel.hydrate(JSON.parse(data?.VacanciesModel))
    this.LegalModel.hydrate(JSON.parse(data?.LegalModel))
    this.TeamPageModel.hydrate(JSON.parse(data?.TeamPageModel))
    this.GDPRModel.hydrate(JSON.parse(data?.GDPRModel))
    this.SaferDatingModel.hydrate(JSON.parse(data?.SaferDatingModel))

    config.hydrate(JSON.parse(data?.config))
  }

  serialize() {
    return {
      GlobalModel: JSON.stringify(this.GlobalModel.serialize()),
      BlogModel: JSON.stringify(this.BlogModel.serialize()),
      SubscriptionModel: JSON.stringify(this.SubscriptionModel.serialize()),
      FaqModel: JSON.stringify(this.FaqModel.serialize()),
      ResponsiveModel: JSON.stringify(this.ResponsiveModel.serialize()),
      ContactUsModel: JSON.stringify(this.ContactUsModel.serialize()),
      VacanciesModel: JSON.stringify(this.VacanciesModel.serialize()),
      LegalModel: JSON.stringify(this.LegalModel.serialize()),
      TeamPageModel: JSON.stringify(this.TeamPageModel.serialize()),
      GDPRModel: JSON.stringify(this.GDPRModel.serialize()),
      SaferDatingModel: JSON.stringify(this.SaferDatingModel.serialize()),

      config: JSON.stringify(config.serialize()),
    }
  }
}
